// src/utils/googleAnalytics.js

const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;
console.log('Valore di GA_MEASUREMENT_ID letto:', GA_MEASUREMENT_ID);
// Funzione per inizializzare GA (chiamata una sola volta al mount dell'app)
export const initGA = () => {
  if (!GA_MEASUREMENT_ID) {
    console.warn("Google Analytics Measurement ID non è impostato. Il tracciamento GA è disabilitato.");
    return;
  }
  // La configurazione iniziale con send_page_view: false è già in index.html.
  // Questa funzione serve più che altro come punto di controllo e conferma.
  console.log(`GA: Inizializzazione con ID: ${GA_MEASUREMENT_ID}`);
  // Non chiamiamo gtag('config') qui di nuovo per evitare doppi invii se già fatto in index.html
  // window.gtag('config', GA_MEASUREMENT_ID, { send_page_view: false }); // Se non fosse in index.html
};

// Funzione per tracciare le visualizzazioni di pagina (o "screen view" per SPA)
// Usiamo 'page_path' e 'page_title' per simulare una visualizzazione di pagina tradizionale
export const trackPageView = (path, title) => {
  if (!window.gtag || !GA_MEASUREMENT_ID) return;
  console.log(`GA: Tracciamento Page View - Path: ${path}, Title: ${title}`);
  window.gtag('event', 'page_view', {
    page_path: path,
    page_title: title,
  });
};

// Funzione per tracciare eventi personalizzati
export const trackEvent = (eventName, params = {}) => {
  if (!window.gtag || !GA_MEASUREMENT_ID) return;
  console.log(`GA: Tracciamento Evento - ${eventName}`, params);
  window.gtag('event', eventName, params);
};